var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "brb-input-group",
        {
          attrs: {
            prepend: _vm.label,
            append: _vm.append,
            required: _vm.required,
            size: _vm.size,
          },
        },
        [
          ["datetime", "date"].includes(_vm.type)
            ? [
                _c("b-input", {
                  class: [
                    "custom-date-time-picker-input",
                    { "text-danger": _vm.isSelectedDateFriday },
                    { "invalid-input": _vm.error },
                  ],
                  staticStyle: { "flex-grow": "2.5 !important" },
                  attrs: {
                    value: _vm.formattedDate,
                    id: `custom-date-picker-input-${_vm.uniqeId}`,
                    readonly: "",
                  },
                }),
                _c(
                  "date-picker",
                  _vm._b(
                    {
                      attrs: {
                        "custom-input": `#custom-date-picker-input-${_vm.uniqeId}`,
                        highlight: _vm.highlight,
                        min: _vm.minDate,
                        max: _vm.maxDate,
                        "display-format": "dddd jYYYY/jMM/jDD",
                        type: "date",
                        format: "YYYY-MM-DD",
                        popover: _vm.popover,
                        "auto-submit": "",
                      },
                      on: { input: _vm.onDateChange },
                      model: {
                        value: _vm.date,
                        callback: function ($$v) {
                          _vm.date = $$v
                        },
                        expression: "date",
                      },
                    },
                    "date-picker",
                    _vm.$attrs,
                    false
                  )
                ),
              ]
            : _vm._e(),
          ["datetime", "time"].includes(_vm.type)
            ? [
                _c("b-input", {
                  class: [
                    "custom-date-time-picker-input",
                    { "invalid-input": _vm.error },
                  ],
                  attrs: {
                    value: _vm.formattedTime,
                    id: `custom-time-picker-input-${_vm.uniqeId}`,
                    readonly: "",
                  },
                }),
                _c(
                  "date-picker",
                  _vm._b(
                    {
                      attrs: {
                        "custom-input": `#custom-time-picker-input-${_vm.uniqeId}`,
                        min: _vm.minTime,
                        max: _vm.maxTime,
                        popover: _vm.popover,
                        type: "time",
                        format: "HH:mm",
                        "display-format": "HH:mm",
                        "auto-submit": "",
                      },
                      on: { input: _vm.onTimeChange },
                      model: {
                        value: _vm.time,
                        callback: function ($$v) {
                          _vm.time = $$v
                        },
                        expression: "time",
                      },
                    },
                    "date-picker",
                    _vm.$attrs,
                    false
                  )
                ),
              ]
            : _vm._e(),
          _vm.model && !_vm.required
            ? _c(
                "brb-btn",
                {
                  staticClass: "position-absolute rounded-circle p-1",
                  staticStyle: {
                    width: "18px",
                    height: "18px",
                    top: "0",
                    bottom: "0",
                    left: "7px",
                    margin: "auto 0",
                    opacity: "0.7",
                  },
                  attrs: { size: "sm" },
                  on: {
                    click: function ($event) {
                      _vm.model = null
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "align-middle",
                    attrs: { icon: "times", size: "xs" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      !_vm.noError && _vm.error && typeof _vm.error === "string"
        ? _c(
            "span",
            { staticClass: "d-block text-right text-danger small mt-2" },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }